function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1952(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30.39,
    height: 17.32,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.474285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 8.66
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17.32,
    width: 30.39,
    height: 17.64,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 26.14
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34.97,
    width: 30.39,
    height: 17.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 43.864999999999995
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52.75,
    width: 30.39,
    height: 21.45,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 63.475
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 74.2,
    width: 30.39,
    height: 22.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.745
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 85.69
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 97.19,
    width: 30.39,
    height: 25.1,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.788888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 109.74
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 122.29,
    width: 30.39,
    height: 25.15,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5149999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 134.865
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 147.44,
    width: 30.39,
    height: 26.43,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.405
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 160.655
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 173.87,
    width: 30.39,
    height: 26.68,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 187.21
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 200.55,
    width: 30.39,
    height: 31.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.341428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 216.07000000000002
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 231.59,
    width: 30.39,
    height: 31.65,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 247.415
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 263.24,
    width: 30.39,
    height: 36.59,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.039
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 281.535
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 299.83,
    width: 30.39,
    height: 38.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 319.015
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 338.2,
    width: 30.39,
    height: 39.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 357.97499999999997
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 377.75,
    width: 30.39,
    height: 42.1,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 398.8
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 419.85,
    width: 30.39,
    height: 42.36,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 441.03000000000003
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 462.21,
    width: 30.39,
    height: 45.78,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.79875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 485.09999999999997
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 507.98,
    width: 30.39,
    height: 47.53,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.341428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 531.745
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 555.52,
    width: 30.39,
    height: 47.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.376666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 579.475
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 603.43,
    width: 30.39,
    height: 48.25,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 627.555
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 651.68,
    width: 30.39,
    height: 48.32,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.078
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.195,
    y: 675.8399999999999
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 0,
    width: 35.56,
    height: 44.85,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.926666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.17,
    y: 22.425
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.95,
    y: 0,
    width: 40.62,
    height: 44.85,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.26,
    y: 22.425
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.56,
    y: 0,
    width: 42.3,
    height: 44.85,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.459999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 127.71000000000001,
    y: 22.425
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.87,
    y: 0,
    width: 44.36,
    height: 44.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.032727272727272
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.05,
    y: 22.425
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.23,
    y: 0,
    width: 47.06,
    height: 44.85,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.4750000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 216.76,
    y: 22.425
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.29,
    y: 0,
    width: 47.32,
    height: 44.85,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.60625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.95,
    y: 22.425
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.61,
    y: 0,
    width: 47.83,
    height: 44.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.2125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.52500000000003,
    y: 22.425
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.44,
    y: 0,
    width: 49.95,
    height: 44.85,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.4750000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.415,
    y: 22.425
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385.39,
    y: 0,
    width: 50.88,
    height: 44.85,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.4750000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 410.83,
    y: 22.425
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.27,
    y: 0,
    width: 51.24,
    height: 44.85,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.89,
    y: 22.425
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.51,
    y: 0,
    width: 51.87,
    height: 44.85,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.983333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.4449999999999,
    y: 22.425
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.38,
    y: 0,
    width: 53.3,
    height: 44.85,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.4750000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.03,
    y: 22.425
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.68,
    y: 0,
    width: 53.31,
    height: 44.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.983333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.3349999999999,
    y: 22.425
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 645.99,
    y: 0,
    width: 54.01,
    height: 44.85,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.995,
    y: 22.425
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 44.85,
    width: 50.7,
    height: 48.81,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.10125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.74,
    y: 69.255
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 93.66,
    width: 50.7,
    height: 49.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.553333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.74,
    y: 118.64999999999999
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 143.64,
    width: 50.7,
    height: 50.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.74,
    y: 169.005
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 194.37,
    width: 50.7,
    height: 51.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.74,
    y: 219.975
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 245.58,
    width: 50.7,
    height: 52.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.3375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.74,
    y: 271.88
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 298.18,
    width: 50.7,
    height: 53.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.450000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.74,
    y: 324.7
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 351.22,
    width: 50.7,
    height: 53.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.74,
    y: 378.05
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 404.88,
    width: 50.7,
    height: 54.21,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.900000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.74,
    y: 431.985
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 459.09,
    width: 50.7,
    height: 57.84,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.3375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.74,
    y: 488.01
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 516.93,
    width: 50.7,
    height: 59.2,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.74,
    y: 546.53
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 576.13,
    width: 50.7,
    height: 61.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2250000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.74,
    y: 606.81
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 637.49,
    width: 50.7,
    height: 62.51,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.3375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.74,
    y: 668.745
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.09,
    y: 44.85,
    width: 52.35,
    height: 61.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.478571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.265,
    y: 75.415
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.45,
    y: 44.85,
    width: 52.8,
    height: 61.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.542857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 159.85,
    y: 75.415
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.25,
    y: 44.85,
    width: 53.8,
    height: 61.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.685714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.15,
    y: 75.415
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.04,
    y: 44.85,
    width: 54.92,
    height: 61.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.153333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.5,
    y: 75.415
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.96,
    y: 44.85,
    width: 55.11,
    height: 61.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.515,
    y: 75.415
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.07,
    y: 44.85,
    width: 55.72,
    height: 61.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.93,
    y: 75.415
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 405.79,
    y: 44.85,
    width: 56.31,
    height: 61.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.94500000000005,
    y: 75.415
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.1,
    y: 44.85,
    width: 59.01,
    height: 61.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.834999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.605,
    y: 75.415
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.11,
    y: 44.85,
    width: 59.29,
    height: 61.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.881666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.755,
    y: 75.415
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.4,
    y: 44.85,
    width: 59.37,
    height: 61.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 610.0849999999999,
    y: 75.415
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 639.77,
    y: 44.85,
    width: 60.23,
    height: 61.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.0575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.885,
    y: 75.415
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.09,
    y: 105.98,
    width: 65.49,
    height: 58.48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.83500000000001,
    y: 135.22
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.09,
    y: 164.46,
    width: 65.49,
    height: 61.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.67875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.83500000000001,
    y: 195.175
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.09,
    y: 225.89,
    width: 65.49,
    height: 64.45,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.161111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.83500000000001,
    y: 258.115
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.09,
    y: 290.34,
    width: 65.49,
    height: 64.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.83500000000001,
    y: 322.80499999999995
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.09,
    y: 355.27,
    width: 65.49,
    height: 66.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.18625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.83500000000001,
    y: 388.33
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.09,
    y: 421.38,
    width: 65.49,
    height: 68.07,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.355714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.83500000000001,
    y: 455.41499999999996
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.09,
    y: 489.46,
    width: 65.49,
    height: 69.24,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.097999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.83500000000001,
    y: 524.0799999999999
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.09,
    y: 558.69,
    width: 65.49,
    height: 69.53,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.915
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.83500000000001,
    y: 593.455
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.09,
    y: 628.22,
    width: 65.49,
    height: 71.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.355714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.83500000000001,
    y: 664.11
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.58,
    y: 105.98,
    width: 62.92,
    height: 76.54,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.98857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.04000000000002,
    y: 144.25
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.5,
    y: 105.98,
    width: 63.14,
    height: 76.54,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.628
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.07,
    y: 144.25
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.65,
    y: 105.98,
    width: 66.46,
    height: 76.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.384444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.88,
    y: 144.25
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.11,
    y: 105.98,
    width: 69.05,
    height: 76.54,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.2625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.635,
    y: 144.25
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.15,
    y: 105.98,
    width: 70.87,
    height: 76.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.124285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.585,
    y: 144.25
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.02,
    y: 105.98,
    width: 71.05,
    height: 76.54,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.545,
    y: 144.25
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.07,
    y: 105.98,
    width: 71.24,
    height: 76.54,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.69,
    y: 144.25
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.3,
    y: 105.98,
    width: 78.7,
    height: 76.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.934285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.65,
    y: 144.25
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.58,
    y: 182.52,
    width: 76.37,
    height: 81.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.54625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.76500000000001,
    y: 223.38500000000002
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.58,
    y: 264.25,
    width: 76.37,
    height: 83.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.274000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.76500000000001,
    y: 306.1
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.58,
    y: 347.95,
    width: 76.37,
    height: 85.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6370000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.76500000000001,
    y: 390.715
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.58,
    y: 433.48,
    width: 76.37,
    height: 86.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6370000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.76500000000001,
    y: 476.69500000000005
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.58,
    y: 519.92,
    width: 76.37,
    height: 88.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.54625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.76500000000001,
    y: 564.145
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.58,
    y: 608.36,
    width: 76.37,
    height: 91.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.728333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.76500000000001,
    y: 654.1800000000001
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.96,
    y: 182.52,
    width: 88.14,
    height: 79.5,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.833333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.03000000000003,
    y: 222.27
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.09,
    y: 182.52,
    width: 94.62,
    height: 79.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.4,
    y: 222.27
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 405.72,
    y: 182.52,
    width: 95.93,
    height: 79.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.68500000000006,
    y: 222.27
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.64,
    y: 182.52,
    width: 98.28,
    height: 79.5,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.78,
    y: 222.27
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.93,
    y: 182.52,
    width: 100.07,
    height: 79.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2272727272727275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.9649999999999,
    y: 222.27
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.96,
    y: 262.01,
    width: 107.17,
    height: 76.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.994285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.545,
    y: 300.49
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.96,
    y: 338.98,
    width: 107.17,
    height: 80.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.1025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.545,
    y: 379.39
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.96,
    y: 419.79,
    width: 107.17,
    height: 91.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.41875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.545,
    y: 465.46500000000003
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.96,
    y: 511.14,
    width: 107.17,
    height: 93.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.545,
    y: 557.9399999999999
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.96,
    y: 604.74,
    width: 107.17,
    height: 95.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.9075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.545,
    y: 652.37
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.13,
    y: 262.01,
    width: 120.06,
    height: 95.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.65857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.15999999999997,
    y: 309.815
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.18,
    y: 262.01,
    width: 122.02,
    height: 95.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.122
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.19,
    y: 309.815
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.2,
    y: 262.01,
    width: 127.8,
    height: 95.61,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.1,
    y: 309.815
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.13,
    y: 357.63,
    width: 144.5,
    height: 103.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.38,
    y: 409.35
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.13,
    y: 461.07,
    width: 144.5,
    height: 107.68,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.38,
    y: 514.91
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.13,
    y: 568.75,
    width: 144.5,
    height: 131.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.40625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.38,
    y: 634.375
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 474.63,
    y: 357.63,
    width: 101.38,
    height: 203.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.482857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.3199999999999,
    y: 459.35
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 576.01,
    y: 357.63,
    width: 123.99,
    height: 203.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.49875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 638.005,
    y: 459.35
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 474.63,
    y: 561.07,
    width: 225.37,
    height: 138.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.315,
    y: 630.5350000000001
  }, "\n        Mecklenburg\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1952);
export default __webpack_public_path__ + "static/media/1952.7c98380062a77e9da2c46cdad353b360.svg";
export { ForwardRef as ReactComponent };